import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CommonDataService } from '../../../common/services/common-data.service';
import { GraphqlService } from '../../../common/services/graphql.service';
@Component({
  selector: 'app-help-xbrlfeature',
  templateUrl: './help-xbrlfeature.component.html'
})
export class HelpXbrlfeatureComponent implements OnInit {

  constructor(public commonDataService: CommonDataService,
    private graphQlService: GraphqlService, private sanitizer: DomSanitizer, private router: Router) { }
  xbrl_heading;
  xbrl_desc;

  ngOnInit(): void {
  
    this.commonDataService.showLoader.next(true);
    this.getxbrlfeaturelabels();
  }
  getxbrlfeaturelabels() {
    this.graphQlService.gethelpxbrlfeatureLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.xbrl_heading = labels.filter(x => x.key == "xbrl_heading").map(y => y.value);
        this.xbrl_desc = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "xbrl_desc").map(y => y.value));
        this.commonDataService.showLoader.next(false);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });

  }
  openlinkbyId(event) {

    let id = event.target.id;
    if (id != "") {
      this.router.navigate([event.target.id]);
    }

  }
}
